<template>
  <b-card>
  <h5 class="card-header text-left">Broadcast <b>Messages</b> :</h5>
  <progress-loader customClass="pull-right" customStyle="width:100px; margin-top: -56px" ref="progress"></progress-loader>
  <div style="max-height:753px; margin-top:20px; overflow-x:hidden; overflow-y:auto">
    <ul class="icons-list list">
      <li v-for="t in tableItems" v-bind:key="t.title" v-if="tableItems.length > 0">
        <div class="font-weight-bold">{{t.title}}</div>
        <small v-html="statusMessage(t)"></small>
        <!-- <small class="text-ellipsis" style="margin-top:5px;width: 60%;display: inline-block;">{{t.content}}</small> -->
        <hr style="margin-bottom:10px" />
        <div class="actions">
          <b-button :href="'#/bcmessage/' + t.uuid" variant="link" class="text-muted"><i class="icon-list"></i></b-button>
        </div>
      </li>
      <li class="text-center" style="padding:100px 0px" v-if="tableItems.length == 0">
        <b-badge>There's no t today</b-badge>
      </li>
      <li class="divider text-center">
        <b-button size="sm" href="#/bcmessage" variant="link" class="text-muted" title="More"><i class="icon-options"></i></b-button>
      </li>
    </ul>
  </div>
  </b-card>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import progressLoader from '@/views/components/progressLoader'

export default {
  name: 'BroadcastMessageList',
  components: {
    progressLoader
  },
  data () {
    return {
      apiUrl: window.AppConfig.apiUrl + 'broadcast-message?limit=10&ascending=0',
      tableItems: []
    }
  },
  mounted () {
    var self = this
    setTimeout(function () {
      try {
        self.getList()
      } catch (err) {
        self.getList()
      }
      self.doAutoRefresh()
    }, Math.floor(Math.random() * 1200) + 1000)
  },
  beforeDestroy () {
    clearInterval(this.refBcMessage)
  },
  methods: {
    getList () {
      this.$refs.progress.activateProgressBar()
      axios.get(this.apiUrl)
        .then(response => {
          if (response === undefined) return false
          this.$refs.progress.deactivateProgressBar()
          if (response !== undefined) {
            this.tableItems = response.data._embedded.broadcastMessage
          } else {
            this.tableItems = []
          }
        })
        .catch(function (error) {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
        }) // .bind(this)
    },

    getDateFormat (value) {
      return moment(value).fromNow() // .format(window.AppConfig.dateFormat)
    },

    doAutoRefresh () {
      this.refBcMessage = setInterval(() => {
        this.getList()
      }, window.AppConfig.IntervalRefreshDataDashboard)
    },

    statusMessage (t) {
      return !t.isPublished ? '<span class="fa fa-text"></span> <em>[Draft]</em>' : '<span class="fa fa-clock-o"></span> Published at ' + this.getDateFormat(t.publishedAt)
    }

    // variant (value) {
    //   let $variant
    //   if (value <= 25) {
    //     $variant = 'info'
    //   } else if (value > 25 && value <= 50) {
    //     $variant = 'success'
    //   } else if (value > 50 && value <= 75) {
    //     $variant = 'warning'
    //   } else if (value > 75 && value <= 100) {
    //     $variant = 'danger'
    //   }
    //   return $variant
    // }
  }
}
</script>

<style>
 /* .first-th, .last-th {
   width: 20px;
 }
 .second-th {
   max-width: 150px;
 }
 .third-th {
   min-width: 150px;
 }
 .content-th {
   min-width: 200px;
 } */
</style>



// WEBPACK FOOTER //
// src/views/index/bcmessageList.vue